import ContentAPI from 'api/content';
import {loadable} from 'router/routes';
import {Page} from './utils';
import {initialState as searchRequestInitialState} from 'search-request/search-request-reducer';

const Home = loadable(() => import('home/Home'));

Home.getInitialState = async ({state}) => ({
    ...state,
    searchRequest: {
        ...searchRequestInitialState,
        pageType: Page.HOME,
    },
    page: await ContentAPI.getHomepage().then(res => res.data),
});

export default Home;
